<template>
<div class="main">

      <v-toolbar dense>

        <v-toolbar-title v-if="isAdmin()" style="margin-left: 40px; text-color:red; cursor:pointer;" @click="home">Auto Key Pro</v-toolbar-title>
        <v-toolbar-title v-else style="margin-left: 40px; text-color:red;">Auto Key Pro</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn v-if="test =='Home'" @click='logout' text color="error">
          Logout
        </v-btn>

        <v-btn v-if="test =='Login'" to="register" text>
          <span>Signup</span>
        </v-btn>

        <v-btn v-if="test =='Signup'" to="login" text>
          <span class="text-color:red">Login</span>
        </v-btn>
      </v-toolbar>

</div>
</template>
<script>
export default {
  props: ['test'],
  created() {

  },
  data: () => ({
    name: null
  }),
  methods: {
    home(){
          this.$router.push('/home');
    },
    isAdmin(){

      return this.$store.state.isAdmin;
    },
    login() {
      this.router.push('login');
    },
    register() {
      this.router.push('register');
    },
    logout() {
      this.$overlay.show(this);
      this.$cookies.remove("token");
      this.$store.commit("setAdmin", false);
      this.$store.commit("setManager", false);
      this.$store.commit("setTech", false);
      this.$store.commit("setToken", null);
      setTimeout(() => {
        this.$overlay.hide();
        this.$router.push("/login")
      }, 500);
    }
  }
}
</script>
<style lang="css" scoped="">

.main{
  background-color: #2a2a2e;
  color: white;
  width: 100%;
  margin-right:5px;
}



</style>
